// extracted by mini-css-extract-plugin
export default {"wrapper":"Zv-z","viewport":"_v-z","container":"aw-z","slide":"bw-z"};